/* CompareViewRenderer.js */

"use strict";
const _ = require("lodash");
const ComboBox = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.Icon
    .ComboBox;
const BrowserDetect = require("@gluenetworks/srvc_core_browser-detect");
const {Diff2HtmlUI} = require("diff2html/lib/ui/js/diff2html-ui.js");
// import { Diff2HtmlUI } from 'diff2html';
const JsonDiff = require("@gluenetworks/json_diff_control").JsonDiffControlComponent;

const Registrations = require("../../../../../../../RegistrationNamespaces");

class CompareViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("compare-view-gl"); //TODO Setup the root Element
        this._editorViewActionElem = document.querySelectorAll(
            "editor-layout-gl .focused_item game-editor-view-actions-gl left-container"
        );
        this._layoutSizeElem = undefined;
        this._layoutViewElem = undefined;
        this._rootElem.component = this._model;
        this._defaultViewActive = false;
        this._compareViewMain = document.createElement("compare-view-main");

        this._model._gameEditor._renderer._rootElem.classList.add("compare-view-game-editor");

        this._documentWidth = document.body.clientWidth;
        this._rootElem.appendChild(this._compareViewMain);
        this.a = {};
        this.b = {};

        this._diffChangedRowElems = [];
        this._focusedRowIndex = undefined;
        this._scrollBehavior = true;
        this._viewActionsAdded = false;
        this._isEdge = BrowserDetect.browser === "Edge";
        this._onScroll = _.debounce(this._onDebouncedScroll, 150);
        this._onDiff = _.debounce(this._onDebouncedDiff, 400);
        this._onPolicyList = _.debounce(this._onDebouncedPolicyList, 150);

        this._getIcon = (op) => {
            if (op.isStable) {
                return "common.star";
            }
            if (_.isUndefined(op.wasDifferentAtCaptureTime)) {
                return "devicemanager.discovered";
            }
            return "configdrift.snapshot";
        };

        this._resObserver = this.observeResize();

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Diff", (this._onDiff = this._onDiff.bind(this)));
        this._model.on("PolicyList", (this._onPolicyList = this._onPolicyList.bind(this)));
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
        this._model.on("SizeChanged", (this._setHeight = this._setHeight.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Diff", this._onDiff);
        this._model.removeListener("Value", this._onPolicyList);
        this._model.removeListener("PolicyList", this._onPolicyList);
        this._model.removeListener("SizeChanged", this._setHeight);
        if (this.jsonDiff) {
            this.jsonDiff.removeListener("JsonDiffNoDiff", this._hideJsonDiff);
            this.jsonDiff.removeListener("JsonDiffHasDiff", this._showJsonDiff);
        }
    }

    _onGridUserRowDoubleClicked(row) {
        const resultsView = Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS;

        const executionEntity = this._model._activityFeed.getEntityById(row.selectedRow);

        if (executionEntity) {
            this._model._gameEditor.setActiveView(
                resultsView,
                [
                    {
                        value: {
                            fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY,
                            viewState: {configExecutionEntity: executionEntity},
                        },
                        content: "Audit Execution Summary",
                        left: {
                            arrow: {
                                direction: "left",
                            },
                        },
                    },
                ],
                {configExecutionEntity: executionEntity, isSubView: true}
            );
        } else {
            this._model._logger.warn(
                {},
                "User clicked on viewResults in the Audit History View for a row that does not have a work."
            );
        }
    }

    _registerViewModeButtonListeners() {
        this._setCompactBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setExpandedBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setSideBySideBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setLineByLineBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
    }

    _unregisterViewModeButtonListeners() {
        this._setCompactBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setExpandedBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setSideBySideBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setLineByLineBtn.removeEventListener("click", this._onActionViewTypeClick);
    }

    _onValue(side, op) {
        if (this[side].optionsComboBox && !_.isEqual(this[side].optionsComboBox.value, op)) {
            this[side].optionsComboBox.setValue(op);
        }
    }
    _onActionViewTypeClick(val) {
        switch (val.currentTarget.title) {
            case "Compact View":
                this._setViewType(true, this._model._viewMode._layoutView);
                break;
            case "Expanded View":
                this._setViewType(false, this._model._viewMode._layoutView);
                break;
            case "Side by Side View":
                this._setViewType(this._model._viewMode._setCompactBtn, "side-by-side");
                break;
            case "Line by Line View":
                this._setViewType(this._model._viewMode._setCompactBtn, "line-by-line");
                break;
        }
    }

    _onDebouncedPolicyList() {
        let ops = this._model.getOptions();
        ["b"].forEach((side) => {
            this[side].optionsComboBox.setOptions(ops);
            let sel =
                this._model.getValue(side).commitHash || this._model.getValue(side).lastCommitHash;
            ops.forEach((op) => {
                if (op.value.id === sel) {
                    this[side].optionsComboBox.setValue(op);
                }
            });
        });
    }

    observeResize() {
        const resObs = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.contentRect && this._model) {
                    this._model.emit("SizeChanged");
                }
            });
        });
        return resObs;
    }

    async _onDebouncedDiff() {
        this._renderCompareOptions();
        await this._renderDiff(...arguments);
        this._renderNavBar();

        return this._model._modalUserFeedback.hideDisplayed();
    }

    _renderCompareOptions() {
        if (!this._optionsContainerElem) {
            this._optionsContainerElem = document.createElement("options-container-gl");
            this.a.optionsContainerElem = document.createElement("a-options-container-gl");
            this.b.optionsContainerElem = document.createElement("b-options-container-gl");

            // A COMBO BOX
            this.a.optionsComboBox = new ComboBox({
                optionIcon: this._getIcon,
                selectedOptionIcon: this._getIcon,
                adjustWidth: false,
                disabled: true,
                placeholder: "Latest Audit Policy",
            });
            this.a.optionsComboBox.on(
                "UserValue",
                (this._onAComboBoxUserValue = this._onAComboBoxUserValue.bind(this))
            );
            this.a.optionsComboBox.renderer.rootElement.classList.add("a-side-gl");
            this.a.optionsContainerElem.appendChild(this.a.optionsComboBox.renderer.rootElement);

            // B COMBO BOX
            //find inital title for B
            let bTitle = "";
            const targetHash = this._model.getValue("b").commitHash;
            this._model.getOptions().forEach((op) => {
                if (op.value.id === targetHash) {
                    bTitle = op.label;
                }
            });
            this.b.optionsComboBox = new ComboBox({
                optionIcon: this._getIcon,
                selectedOptionIcon: this._getIcon,
                adjustWidth: false,
                placeholder: bTitle,
            });
            this.b.optionsComboBox.on(
                "UserValue",
                (this._onBComboBoxUserValue = this._onBComboBoxUserValue.bind(this))
            );
            this.b.optionsComboBox.renderer.rootElement.classList.add("b-side-gl");
            this.b.optionsContainerElem.appendChild(this.b.optionsComboBox.renderer.rootElement);

            // CONTAINERS
            this._optionsContainerElem.appendChild(this.a.optionsContainerElem);
            this._optionsContainerElem.appendChild(this.b.optionsContainerElem);
            this._compareViewMain.appendChild(this._optionsContainerElem);
        }

        let as = this._model.getValue("a");
        let bs = this._model.getValue("b");
        if (as) {
            this.a.optionsComboBox.setValue(as);
        }
        if (bs) {
            this.b.optionsComboBox.setValue(bs);
        }
        this._onDebouncedPolicyList();
    }

    _removeCompareOptions() {
        if (this._optionsContainerElem) {
            let promArr = [this.a.optionsComboBox.shutdown(), this.b.optionsComboBox.shutdown()];

            return Promise.resolve(promArr)
                .then(() => {
                    this.a.optionsContainerElem.remove();
                    this.a.optionsContainerElem = undefined;
                    this.a = {};
                    // B
                    this.b.optionsContainerElem.remove();
                    this.b.optionsContainerElem = undefined;
                    this.b = {};
                    // container
                    this._optionsContainerElem.remove();
                    this._optionsContainerElem = undefined;
                })
                .catch((err) => {
                    this.model._logger.warn(
                        {error: err},
                        "CompareViewRenderer._removeCompareOptions() error."
                    );
                });
        } else {
            return Promise.resolve();
        }
    }

    async _onAComboBoxUserValue(value) {
        await this._model.setValues(...this._getABValues(value, "a"));
    }

    async _onBComboBoxUserValue(value) {
        await this._model.setValues(...this._getABValues(value, "b"));
    }

    _getABValues(val, comboBox = "b") {
        // setting default logic assuming selected is b side
        let a = null,
            b = null;
        if (comboBox === "a") {
            const aId = this.a.optionsComboBox.getValue().id;

            for (const aVal of this._model._params.compareVals) {
                if (aVal.commitHash === aId) {
                    a = aVal.data;
                }
            }
        } else {
            const bId = this.b.optionsComboBox.getValue().id;

            for (const bVal of this._model._params.compareVals) {
                if (bVal.commitHash === bId) {
                    b = bVal;
                }
            }
        }

        return [a, b];
    }

    _renderNavBar() {
        if (!this._infoElem) {
            this._infoElem = document.createElement("nav-bar-container-gl");
            this._compareViewMain.appendChild(this._infoElem);
        }

        if (this._model._diffTooLarge) {
            this._infoElem.classList.add("hidden");
        } else {
            this._infoElem.classList.remove("hidden");
        }

        let diff = this._model.getDiffString();
        if (_.isEmpty(diff)) {
            return;
        }

        if (!_.isEmpty(this._diffChangedRowElems)) {
            this._hideDefaultMessageDisplay();
            if (this._contentIdenticalElem) {
                this._contentIdenticalElem.remove();
                this._contentIdenticalElem = undefined;
                this._contentIdenticalIcon.remove();
                this._contentIdenticalIcon = undefined;
            }

            // PREV
            if (!this._prevElem) {
                this._prevElem = document.createElement("actionable-icon-gl");
                this._prevElem.dataset.icon = "common.chevron";
                this._prevElem.classList.add("previous-icon");
                this._prevElem.addEventListener("click", (this._onPrev = this._onPrev.bind(this)));
                this._infoElem.appendChild(this._prevElem);
            }

            // FOCUS INDEX
            if (!this._focusInfoElem) {
                this._focusInfoElem = document.createElement("diff-focus-info-gl");
                this._infoElem.appendChild(this._focusInfoElem);
            }

            // NEXT
            if (!this._nextElem) {
                this._nextElem = document.createElement("actionable-icon-gl");
                this._nextElem.dataset.icon = "common.chevron";
                this._nextElem.classList.add("next-icon");
                this._nextElem.addEventListener("click", (this._onNext = this._onNext.bind(this)));
                this._infoElem.appendChild(this._nextElem);
            }

            // LINE NUMBER
            if (!this._lineNumElem) {
                this._lineNumElem = document.createElement("diff-line-num-gl");
                this._infoElem.appendChild(this._lineNumElem);
            }

            let changeCount = this._diffChangedRowElems.length;
            this._focusInfoElem.innerHTML = this._diffChangedRowElems.length + " changes";
            if (_.isNumber(this._focusedRowIndex)) {
                this._focusInfoElem.innerHTML = this._focusedRowIndex + 1 + "/" + changeCount;
                let rowEl = this._diffChangedRowElems[this._focusedRowIndex];
                let lineNum =
                    this.model.viewMode.layoutView === "side-by-side"
                        ? rowEl.querySelector(".d2h-code-side-linenumber").innerHTML
                        : rowEl.querySelector(".d2h-code-linenumber").innerHTML;
                this._lineNumElem.innerHTML = "line " + lineNum;
            } else {
                this._focusInfoElem.innerHTML = "0/" + changeCount;
                this._lineNumElem.innerHTML = "";
            }
        } else {
            if (this._prevElem) {
                this._prevElem.remove();
                this._prevElem = undefined;
                this._nextElem.remove();
                this._nextElem = undefined;
                this._focusInfoElem.remove();
                this._focusInfoElem = undefined;
                this._lineNumElem.remove();
                this._lineNumElem = undefined;
            }
            this._removeDiff();
        }
    }

    _removeNavBar() {
        if (this._infoElem) {
            this._infoElem.remove();
            this._infoElem = undefined;
        }
    }

    /**
     * Syncing Scroll bars:
     * A hack put in place until we can create our own Diff Renderer Component.
     * The reason is scroll sync no longer works when we override the default styles to get horizontal scroll bars
     * visible within the app, instead of having to scroll to the bottom to get access to them.
     * @private
     */

    _syncScrolling() {
        this._d2h_code_wrapper_elems =
            this._compareViewMain.querySelectorAll(".d2h-file-side-diff");
        if (!_.isEmpty(this._d2h_code_wrapper_elems)) {
            this._d2h_code_wrapper_elems.forEach((el) => {
                el.addEventListener("scroll", (this._onScroll = this._onScroll.bind(this)));
            });
        }
    }

    _onDebouncedScroll(evt) {
        let st = evt.target.scrollTop;
        let sl = evt.target.scrollLeft;
        this._d2h_code_wrapper_elems.forEach((el) => {
            if (!_.isEqual(el.scrollTop, st)) {
                el.scrollTop = st;
            }
            if (!_.isEqual(el.scrollLeft, sl)) {
                el.scrollLeft = sl;
            }
        });
    }

    async _renderDiff() {
        let ds = this._model.getDiffString();
        this._displayDiff(ds);
        return Promise.resolve();
    }

    _displayDiff(ds) {
        //do it different
        if (_.isEqual(this._model.getValue("a").data, this._model.getValue("b").data)) {
            this._showPolicyIdenticalMessageDisplay();
        }

        this._removeDiff();
        this._jPolicyContainerElem && this._jPolicyContainerElem.remove();
        this._policyContainerElem = document.createElement("compare-container-gl");
        this._policyContainerElem.setAttribute(
            "class",
            this.model.viewMode.compactView === true ? "compactView" : "fullView"
        );
        if (this.model.viewMode.layoutView === "line-by-line") {
            this._policyContainerElem.classList.add("line_by_line");
        }

        this._compareViewMain.appendChild(this._policyContainerElem);

        if (!_.isEmpty(ds)) {
            const config = {
                synchronisedScroll: false,
                matching: "none",
                outputFormat: this.model.viewMode.layoutView,
                showFiles: false,
                matchingMaxComparisons: 1000,
                drawFileList: false,
            };
            const targetElement = this._policyContainerElem;
            const diff2htmlUi = new Diff2HtmlUI(targetElement, ds, config);
            diff2htmlUi.draw();

            this._findAndAggregateChangedRows();
            this._addViewActions();
            this._syncScrolling();
            let sideDiffContainers =
                this._policyContainerElem.querySelectorAll(".d2h-file-side-diff");
            if (!_.isEmpty(sideDiffContainers) && !_.isEmpty(this._diffChangedRowElems)) {
                this.a.diffContainer = sideDiffContainers[0];
                this.b.diffContainer = sideDiffContainers[1];
            }
            this._setActiveButton();
        } else {
            this._removeViewActions();
        }

        if (_.isEmpty(this._diffChangedRowElems) && !_.isUndefined(ds)) {
            //Check if the difflines are 0 but the whole entity is not undefined i.e. Identical
            this._removeViewActions();
            this._policyContainerElem.remove();
        }
        this._model._gameEditor._renderer._rootElem.classList.remove("json-compare-view");

        /* add the extra tr to show the vertical bar */
        const tableTbodyElems = this._policyContainerElem.querySelectorAll("table tbody");
        if (tableTbodyElems) {
            tableTbodyElems.forEach((eachTbody) => {
                const newTr = document.createElement("tr");
                newTr.classList.add("just-the-bar");
                eachTbody.insertBefore(newTr, eachTbody.firstChild);
            });
        }
    }

    _removeDiff() {
        if (this._policyContainerElem) {
            this._diffUi = undefined;
            this._policyContainerElem.remove();
            this._policyContainerElem = undefined;
            _.set(this.a, "diffContainer", undefined);
            _.set(this.b, "diffContainer", undefined);
        }
    }

    _addViewActions() {
        if (!this._viewActionsAdded) {
            let _actionElem = false;

            if ((_actionElem = _.get(this._editorViewActionElem, 0, false))) {
                _actionElem.classList.add("compare-icons");
                this._layoutSizeElem = document.createElement("layout-size");
                _actionElem.appendChild(this._layoutSizeElem);
                this._setCompactBtn = document.createElement("actionable-icon-gl");
                this._setCompactBtn.dataset.icon = "configdrift.compare_compact";
                this._setCompactBtn.setAttribute("title", "Compact View");
                this._layoutSizeElem.appendChild(this._setCompactBtn);

                this._setExpandedBtn = document.createElement("actionable-icon-gl");
                this._setExpandedBtn.dataset.icon = "configdrift.compare_expanded";
                this._setExpandedBtn.setAttribute("title", "Expanded View");
                this._layoutSizeElem.appendChild(this._setExpandedBtn);

                this._layoutViewElem = document.createElement("layout-view");
                _actionElem.appendChild(this._layoutViewElem);

                this._setSideBySideBtn = document.createElement("actionable-icon-gl");
                this._setSideBySideBtn.dataset.icon = "configdrift.compare_side_by_side";
                this._setSideBySideBtn.setAttribute("title", "Side by Side View");
                this._layoutViewElem.appendChild(this._setSideBySideBtn);

                this._setLineByLineBtn = document.createElement("actionable-icon-gl");
                this._setLineByLineBtn.dataset.icon = "configdrift.compare_line_by_line";
                this._setLineByLineBtn.setAttribute("title", "Line by Line View");
                this._layoutViewElem.appendChild(this._setLineByLineBtn);

                this._registerViewModeButtonListeners();
            }

            this.model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Back",
                name: "goBack",
                handler: (this._back = this._back.bind(this)),
            });

            this.model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Apply",
                name: "applyThisCommit",
                handler: (this._applyThisCommit = this._applyThisCommit.bind(this)),
            });

            this._viewActionsAdded = true;
        }
    }

    _setViewType(isCompactView, viewType) {
        this._model._diffTooLarge = false;
        this.model.viewMode.setViewProps(isCompactView, viewType);
        this._setActiveButton(isCompactView, viewType);
    }

    _setActiveButton(isCompactBtn = undefined, viewTypeBtn = undefined) {
        if (![isCompactBtn, viewTypeBtn].every((i) => i === undefined)) {
            if (isCompactBtn) {
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Compact View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Expanded View']"
                    ),
                    0
                ).classList.remove("active");
            } else {
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Expanded View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Compact View']"
                    ),
                    0
                ).classList.remove("active");
            }

            if (viewTypeBtn === "side-by-side") {
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Side by Side View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Line by Line View']"
                    ),
                    0
                ).classList.remove("active");
            } else {
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Line by Line View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Side by Side View']"
                    ),
                    0
                ).classList.remove("active");
            }
        } else {
            this._setActiveButton(
                this._model._viewMode._compactView,
                this._model._viewMode._layoutView
            );
        }
    }

    _removeViewActions() {
        if (this._viewActionsAdded) {
            this.model.gameEditor.clearViewActions();
            this._viewActionsAdded = false;
            this._hasSwitchAction = false;
        }
    }

    _applyThisCommit() {
        const commitInfo = this.b.optionsComboBox.getValue();

        this._model._modalUserFeedback.hideDisplayed().then(() => {
            const msg = `<div class="commit-apply-message">
            <p>You are about to apply the following Audit Policy configuration:</p>
            <ul>
            <li>Commit Hash: ${commitInfo.value.id} </li>
            <li>Date: ${commitInfo.value.timestamp} </li>
            </ul>
            <p>This will redirect you to the Config Audit Details view with the selected commit's data applied.</p>
            <p>Please review all properties prior to saving as some references may have been removed or renamed.</p>
            <p>When ready, you must save the form to apply the changes.</p></div>`;
            this._model._modalUserFeedback
                .displayConfirmation(msg, {
                    title: "Apply Version",
                    confirmDetails: {
                        text: "Apply",
                        type: "additive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                    enableHtml: true,
                })
                .then(() => {
                    this._model.switchView(Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS, {
                        commitHash: commitInfo.value.id,
                    });
                })
                .catch(() => {
                    return Promise.resolve();
                });
        });
    }

    _back() {
        this._model.switchView(Registrations.AUDIT_POLICY_EDITOR_VIEW_VERSIONS);
    }

    _switchViewType() {
        if (this._jPolicyContainerElem) {
            this._jPolicyContainerElem.remove();
            this._jPolicyContainerElem = undefined;
        }
        this._model._isJsonView = !this._model._isJsonView;

        if (this._model._isJsonView) {
            this._model._viewType = "json";
            this._model._userDataStorage.setData("json", "viewType");
        } else {
            this._model._viewType = "text";
            this._model._userDataStorage.setData("text", "viewType");
        }
    }

    _filterName(name) {
        return name.replace(/\s|:|\*|-|\/|\\/g, "_");
    }

    _onNext() {
        if (!_.isEmpty(this._diffChangedRowElems)) {
            if (_.isNumber(this._focusedRowIndex)) {
                this._diffChangedRowElems[this._focusedRowIndex].classList.remove("focused");
                if (this._focusedRowIndex < this._diffChangedRowElems.length - 1) {
                    this._focusedRowIndex++;
                } else {
                    this._focusedRowIndex = 0;
                }
            } else {
                this._focusedRowIndex = 0;
            }
            if (_.isNumber(this._focusedRowIndex)) {
                let rowElem = this._diffChangedRowElems[this._focusedRowIndex];
                rowElem.classList.add("focused");
                if (this._isEdge) {
                    rowElem.scrollIntoView(this._scrollBehavior);
                } else {
                    rowElem.focus();
                }
            }
        }
        this._renderNavBar();
    }

    _onPrev() {
        if (!_.isEmpty(this._diffChangedRowElems)) {
            if (_.isNumber(this._focusedRowIndex)) {
                this._diffChangedRowElems[this._focusedRowIndex].classList.remove("focused");
                if (this._focusedRowIndex > 0) {
                    this._focusedRowIndex--;
                } else {
                    this._focusedRowIndex = this._diffChangedRowElems.length - 1;
                }
            } else {
                this._focusedRowIndex = this._diffChangedRowElems.length - 1;
            }

            let rowElem = this._diffChangedRowElems[this._focusedRowIndex];
            rowElem.classList.add("focused");
            if (this._isEdge) {
                rowElem.scrollIntoView(this._scrollBehavior);
            } else {
                rowElem.focus();
            }
        }
        this._renderNavBar();
    }

    _findAndAggregateChangedRows() {
        this._focusedRowIndex = undefined;
        this._diffChangedRowElems = [];
        let tableTbodyElems = this._policyContainerElem.querySelectorAll("table tbody");
        if (!_.isEmpty(tableTbodyElems)) {
            this.a.rowElems = tableTbodyElems[0].querySelectorAll("tr");
            this.b.rowElems =
                this.model.viewMode.layoutView === "side-by-side"
                    ? tableTbodyElems[1].querySelectorAll("tr")
                    : [];
            let query = ".d2h-change, .d2h-del, .d2h-ins";
            if (!_.isEmpty(this.b.rowElems) && this.model.viewMode.layoutView === "side-by-side") {
                let lastRowFocused = {a: false, b: false}; // we only want the first row within a group of changes. Otherwise each row is treated like a unique change.
                _.each(this.a.rowElems, (a_row, idx) => {
                    let aChangedRow = a_row.querySelector(query);
                    let b_row = this.b.rowElems[idx];
                    let bChangedRow = b_row.querySelector(query);
                    if (aChangedRow) {
                        if (!lastRowFocused.a) {
                            a_row.setAttribute("tabindex", -1);
                            a_row._glSide = "a";
                            this._diffChangedRowElems.push(a_row);
                        }
                    } else if (bChangedRow) {
                        if (!lastRowFocused.b) {
                            b_row.setAttribute("tabindex", -1);
                            b_row._glSide = "b";
                            this._diffChangedRowElems.push(b_row);
                        }
                    }
                    if (aChangedRow) {
                        lastRowFocused.a = true;
                    } else {
                        lastRowFocused.a = false;
                    }
                    if (bChangedRow) {
                        lastRowFocused.b = true;
                    } else {
                        lastRowFocused.b = false;
                    }
                });
            } else if (this.model.viewMode.layoutView === "line-by-line") {
                _.each(this.a.rowElems, (a_row) => {
                    let aChangedRow = a_row.querySelector(query);
                    if (aChangedRow) {
                        a_row.setAttribute("tabindex", -1);
                        a_row._glSide = "a";
                        this._diffChangedRowElems.push(a_row);
                    }
                });
            }
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._hideDefaultMessageDisplay();
        this._model._gameEditor._renderer._rootElem.classList.remove("json-compare-view");

        const bottomBar = this._model._gameEditor._viewActionsCmpnt._renderer._rootElem;
        bottomBar.removeAttribute("style");
        this._model._gameEditor._renderer._rootElem.classList.remove("compare-view-game-editor");

        this._unregisterListeners();
        this._resObserver.unobserve(this._compareViewMain);
        if (
            ![
                this._setCompactBtn,
                this._setExpandedBtn,
                this._setSideBySideBtn,
                this._setLineByLineBtn,
            ].every(undefined)
        ) {
            this._unregisterViewModeButtonListeners();
        }
        let promArr = [this._removeCompareOptions()];

        return Promise.all(promArr).then(
            () => {
                this._compareViewMain.remove();
                this._rootElem.remove();

                this.a = undefined;
                this.b = undefined;
                this._defaultViewActive = undefined;
                this._editorViewActionElem = undefined;
                this._layoutSizeElem = undefined;
                this._layoutViewElem = undefined;
                this._removeDiff();
                this._removeNavBar();
                this._model = undefined;
                this._compareViewMain.remove();
                this._compareViewMain = undefined;
                if (
                    ![
                        this._setCompactBtn,
                        this._setExpandedBtn,
                        this._setSideBySideBtn,
                        this._setLineByLineBtn,
                    ].every(undefined)
                ) {
                    this._setCompactBtn = undefined;
                    this._setExpandedBtn = undefined;
                    this._setSideBySideBtn = undefined;
                    this._setLineByLineBtn = undefined;
                }
            },
            (err) => {
                this.model._logger.warn({error: err}, "CompareViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.whenModelIsReady().then(() => {
            this.objA = this._model._params.compareVals[0];
            this.objB = this._model._params.compareVals[1];

            this.jsonDiff = new JsonDiff({
                theme: "light",
                context: this,
                actions: {
                    switchView: {
                        name: "switchView",
                        display: "Text",
                        cb: this._switchViewType.bind(this),
                        position: "left",
                    },
                },
            });
            this.jsonDiff.renderer.render();

            this.jsonDiff.on(
                "JsonDiffNoDiff",
                (this._hideJsonDiff = this._hideJsonDiff.bind(this))
            );
            this.jsonDiff.on(
                "JsonDiffHasDiff",
                (this._showJsonDiff = this._showJsonDiff.bind(this))
            );
            this._rootElem.setAttribute("id", this.model.id);
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _setHeight() {
        this.jsonDiff.setHeight(this._compareViewMain.clientHeight - 70);
    }

    _onDisplayMode() {
        const isCompactView = this.model.viewMode.compactView,
            currentLayoutView = this.model.viewMode.layoutView;
        if (isCompactView === true) {
            this.model.viewMode.setViewProps(
                !isCompactView,
                currentLayoutView === "line-by-line"
                    ? "side-by-side"
                    : currentLayoutView === "side-by-side"
                    ? "line-by-line"
                    : currentLayoutView
            );
        } else {
            this.model.viewMode.setViewProps(!isCompactView);
        }
    }

    _uClickedABro(/*event*/) {
        let activeSelection = this.a.optionsComboBox.getValue();
        if (!_.isUndefined(activeSelection) && !_.isUndefined(activeSelection.id)) {
            this._onSetDefaultSnapshotConfirm(activeSelection);
        }
    }

    _uClickedBBro(/*event*/) {
        let activeSelection = this.b.optionsComboBox.getValue();
        if (!_.isUndefined(activeSelection) && !_.isUndefined(activeSelection.id)) {
            this._onSetDefaultSnapshotConfirm(activeSelection);
        }
    }

    _onSetDefaultSnapshotConfirm(snapshot) {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: `Set Configuration Snapshot ${snapshot.name} as new default?`,
                title: "Set Default Configuration",
                confirmDetails: {
                    text: "Confirm",
                    type: "additive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                return this._model.makeDefaultSnapshot(snapshot.id);
            }
        );
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _showDefaultMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "No audit policy available",
            })
            .then(() => {
                this._defaultViewActive = true;
            });
        this._rootElem.parentNode.classList.add("no-comparison");

        const messageRootElement = _.get(
            this._model.gameEditor._defaultMessageViewCmpnt,
            "_renderer._rootElem",
            false
        );
        if (messageRootElement) {
            this._compareViewMain.append(messageRootElement);
        }
    }

    _showPolicyIdenticalMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "Audit policies are the same",
                icon: "configdrift.same",
            })
            .then(() => {
                this._defaultViewActive = true;
            });
        this._rootElem.parentNode.classList.add("policies-identical");

        const messageRootElement = _.get(
            this._model.gameEditor._defaultMessageViewCmpnt,
            "_renderer._rootElem",
            false
        );
        if (messageRootElement) {
            this._compareViewMain.append(messageRootElement);
        }
    }

    _hideDefaultMessageDisplay() {
        this._model.gameEditor.hideDefaultMessageView().then(() => {
            this._defaultViewActive = false;
        });
        this._rootElem.parentNode.classList.remove("policies-identical");
        this._rootElem.parentNode.classList.remove("no-comparison");
    }

    _hideJsonDiff() {
        if (this._jPolicyContainerElem) {
            this._jPolicyContainerElem.classList.add("vishidden");
            this._showPolicyIdenticalMessageDisplay();
        }
    }

    _showJsonDiff() {
        if (
            this._jPolicyContainerElem &&
            typeof this._jPolicyContainerElem.classList !== "undefined"
        ) {
            this._jPolicyContainerElem.classList.remove("vishidden");
            this._hideDefaultMessageDisplay();
        }
    }

    _isEmptyCommandSet(obj) {
        if (!obj || typeof obj !== "object") {
            return true;
        }
        for (const key in obj) {
            if (
                key !== "commandSetName" &&
                Object.prototype.hasOwnProperty.call(obj, key) &&
                Array.isArray(obj[key]) &&
                obj[key].length > 0
            ) {
                return false; // At least one non-empty array found
            }
        }
        return true; // All arrays are empty or no arrays found
    }

    getDiffClass(item1, item2, key) {
        // Defensive: handle undefined/null key and item objects
        const specialKeys = ["command", "conceptItemName", "getUrl", "restSyncItemName"];
        if (specialKeys.indexOf(key) > -1) {
            const resp1 = item1 && typeof item1 === "object" ? item1.responseStr : undefined;
            const resp2 = item2 && typeof item2 === "object" ? item2.responseStr : undefined;
            if (!resp1 && !resp2) {
                return "";
            }
            if (!resp1) {
                return "added";
            }
            if (!resp2) {
                return "removed";
            }
            return resp1 === resp2 ? "" : "updated";
        }

        if (!item1 && !item2) {
            return "";
        }
        if (!item1) {
            return "added";
        }
        if (!item2) {
            return "removed";
        }
        try {
            return JSON.stringify(item1) === JSON.stringify(item2) ? "" : "updated";
        } catch (e) {
            // If circular reference or error, treat as updated
            return "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = CompareViewRenderer;
